/** Internal global with common properties and Sentry extensions  */

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ = globalThis ;

export { GLOBAL_OBJ };
//# sourceMappingURL=worldwide.js.map
